import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const solana = {
  displayName: 'Solana',
  runtime: 'svm',
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 2,

  decoration: {
    color: '#42D2C2',
    contrastColor: getContrastColor('#42D2C2'),
  },
  features: {
    wallet: { supported: true, import: true },
    vault: {
      supported: true,
      ccqRecovery: true,
    },
  },
  connectivity: {
    rpc: {},
    blockExplorers: {
      primary: {
        base: 'https://orbmarkets.io',
        token: 'https://orbmarkets.io/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    debridge: { chainKey: '7565164' },
    houdini: { chainKey: 'SOL' },
    lifi: { chainKey: 'SOL' },
    stargate: { chainKey: 'solana' },
    okx: { chainKey: '501' },
  }),
  services: defaultServices({
    codex: {
      networkId: 1399811149,
      nativeLiquidityAddress: 'So11111111111111111111111111111111111111112',
    },
    defiLlama: { chainKeys: ['solana'] },
    trm: { chainKey: 'solana' },
    zerion: { chainKey: 'solana' },
    coingecko: {
      networkId: 'solana',
      platformId: 'solana',
    },
    coingeckoDex: {
      networkId: 'solana',
    },
    qnStreams: {
      networkKey: 'solana-mainnet',
    },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {
    prod: {
      maxDailyWithdrawals: 20,
    },
  }),
} as const satisfies AllChainConfig<'svm', true>;
